export default class MyGiftCard {
  constructor(args) {
    this.id = args.id || "-1";
    this.barcode = args.barcode || "";
    this.name = args.name || "";
    this.originalAmount = args.originalAmount || 0;
    this.restAmount = args.restAmount || 0;
    this.giftCardFrom = args.giftCardFrom || "";
    this.message = args.message || "";
    this.imageUrl = args.imageUrl || "";
    this.status = args.status || 0;
    this.expirationDate = args.expirationDate || "";
    this.usageArea = args.usageArea || 0;
    this.messageUrlType = args.messageUrlType || "";
    this.usageDescription = args.usageDescription || "";
    this.messageUrl = args.messageUrl || "";
  }
}
